import Vue from 'vue'
// import Resource from 'vue-resource'
import Router from 'vue-router'

import index from '@/components/introduction/index-view.vue'
// 加入我们
import JoinUs from '@/components/join/JoinUs.vue'
// 发动机
import Engine from '@/components/engine/engine.vue'
// 能源
import Energy from '@/components/energy/energy.vue'
// 爆震
import Knocking from '@/components/Knocking/knocking.vue'
//关于
import About from '@/components/about/about.vue'

Vue.use(Router)
const changePush = Router.prototype.push;
Router.prototype.push = function push(location){
    return changePush.call(this, location).catch(err => err);
}
const router = new Router({
  mode: 'hash',
  routes: [
    {
        path: '/',
        title: '公司简介',
        component: index,
        meta:{
          title:"清航空天"
        }
      },
    //涡喷发动机
    {
        path:'/engine',
        title:'航空动力',
        component:Engine,
        meta: { title: '航空动力' }
    }, 
    //能源
    {
        path:'/energy',
        title:'绿色能源',
        component:Energy,
        meta: { title: '绿色能源' }
    },
    //爆震
    {
        path:'/knocking',
        title:'爆震技术',
        component:Knocking,
        meta: { title: '爆震技术' }
    },
    // 加入我们
    {
      path: '/joinus',
      title: '加入我们',
      component: JoinUs,
      meta: { title: '加入我们' }
    },
    ,
    // 关于我们
    {
      path: '/about',
      title: '关于我们',
      component: About,
      meta: { title: '关于我们' }
    },
    
  ]
})

export default router
